/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const r=r=>Array.isArray(r)&&"number"!=typeof r[0];export{r as isEasingArray};
//# sourceMappingURL=is-easing-array.js.map
